import React from "react";
import { myCollegesList } from "./CollegeList";

function MyColleges() {
  console.log(myCollegesList);
  return <div>MyColleges</div>;
}

export default MyColleges;
